export default "__VITE_ASSET__CV6LeUCf__"